import { LEAD_STATUSES } from "../../Lead/constants/lead-statuses.ts"

/**
 * What the archive endpoint accepts as a target — mirrors
 * `Lead.get_archived_statuses()` in ezbuild_back. Distinct from
 * `archiveLeadStatuses`, which is about which leads the UI treats as already
 * archived and deliberately still counts Won.
 */
const ARCHIVE_LEAD_STATUSES = [
  LEAD_STATUSES.NURTURING,
  LEAD_STATUSES.LOST,
  LEAD_STATUSES.UNQUALIFIED,
  LEAD_STATUSES.DO_NOT_CONTACT
] as const

/**
 * What the UI treats as "this lead is already archived" — it gates the status
 * cell's restore-only dropdown and hides a second Archive action. Do Not
 * Contact belongs here for the same reason Lost does: without it the cell
 * offers a converted lead's worth of lifecycle stages the endpoint refuses,
 * and a one-click stage change would slip past the restore confirmation the
 * Inactive page enforces for exactly this transition.
 */
const archiveLeadStatuses = [
  LEAD_STATUSES.UNQUALIFIED,
  // LEAD_STATUSES.NURTURING,
  LEAD_STATUSES.LOST,
  LEAD_STATUSES.DO_NOT_CONTACT,
  LEAD_STATUSES.WON
]

const archiveLeadAllowedStatuses = [LEAD_STATUSES.NEW, LEAD_STATUSES.CONTACTED]

export {
  ARCHIVE_LEAD_STATUSES,
  archiveLeadAllowedStatuses,
  archiveLeadStatuses
}
